import NotFound from '../components/NotFound';
import { __ } from '../utils';
import { Stack } from '@presov.sk/presov-ui-react';
import React from 'react';

const NotFoundPage: React.FC = () => (
  <Stack
    sx={{
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'fit-content',
      margin: 'auto',
      gap: 2,
    }}
  >
    <NotFound
      message={__('Stránka nebola nájdená')}
      caption={__('Skontrolujte URL adresu alebo sa vráťte na hlavnú stránku.')}
      backUrl='/'
      backText={__('Späť na hlavnú stránku')}
    />
  </Stack>
);

export default NotFoundPage;
